<app-card>
    <div class="row justify-content-center">
        <div class="col-md-5">
            <h5 class="mb-1"><strong>Re Instate Withdrawn Application for application ref # {{application?.reference}}</strong></h5>
            <form (ngSubmit)="onSubmit()" #ngForm="ngForm" #userForm="ngForm" [ngClass]="validated?'was-validated':''" style="z-index: 1000;">   
                <div class="mb-4 text-center">
                    <img src="/assets/images/nsfas_logo.png" class="mt-3 mb-5" style="height: 177px;">
                </div>
                <p class="mb-1 text-primary"><strong>Re-Instate reason</strong></p>
                <div class="input-group mb-3">
                    <select autocomplete="off" class="form-select" appReInstateWithdrawReason [(ngModel)]="application.reInstateWithdrawReason" name="reInstateWithdrawReason" required></select>
                    <div class="invalid-feedback">
                        Re-Instate reason is required
                    </div>
                </div>

                <!--<div class="mb-5 mt-2" *ngIf="application.status =='Withdrawn'">
                    <div class="mb-3">
                        <label for="formFileSm" class="form-label">Upload certified copy of ID to verify re-instating</label>
                        <input required [(ngModel)]="application.reInstateWithdrawDocument" appFileUpload name="reInstateWithdrawDocument" accept="image/*,.pdf"
                            class="form-control form-control-sm" id="formFileSm" type="file">
                        <div class="invalid-feedback">
                        certified copy of ID is required
                        </div>
                    </div>
                    <small class="ps-3" *ngIf="!application.reInstateWithdrawDocument">PDF or Jpeg, max 20mb</small>
                    <small class="ps-3" *ngIf="application.reInstateWithdrawDocument">{{application.reInstateWithdrawDocument.name}}</small>
                </div>-->
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <button class="btn btn-primary btn-lg mb-3" type="submit">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</app-card>